/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsAddCatalogOrgAccess } from "../../funcs/llmModelsAddCatalogOrgAccess.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.AddModelCatalogOrgAccessRequest$inboundSchema,
};

export const tool$llmModelsAddCatalogOrgAccess: ToolDefinition<typeof args> = {
  name: "llm-models-add-catalog-org-access",
  description: `Add cluster model access for an organization

Idempotently adds availability without activating or revoking any model names.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsAddCatalogOrgAccess(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
